module.exports = __webpack_public_path__ + "static/img/sustainable-strategy_01_2025.ef07c94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-strategy_01_2025.jpg
// module id = a2dD
// module chunks = 99